<template>
  <div v-loading="productDetailIng" class="edit-product">
    <el-form
      ref="editProductForm"
      class="prudoct-form"
      :model="editProductForm"
      label-width="160px"
      :rules="editProductFormRules"
    >
      <div class="box">
        <div class="title">基本信息</div>
        <el-row>
          <el-col :span="24">
            <el-form-item label="商品名称：" class="skuName" prop="skuName">
              <el-input v-model="editProductForm.skuName"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="品牌：">
              <span>
                {{ editProductForm.brandName }}
              </span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <!-- <el-form-item label="税率(%)：" prop="taxRateId">
              <el-select
                v-model="editProductForm.taxRateId"
                @change="taxRateChange"
                placeholder="请选择税率"
              >
                <el-option
                  v-for="taxitem in taxList"
                  :key="taxitem.taxRateId"
                  :label="taxitem.taxRate"
                  :value="taxitem.taxRateId"
                >
                  <span>{{ taxitem.taxRate }}</span>
                </el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item label="税率(%)：">
              <span>
                {{ editProductForm.taxRateValue }}
              </span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="所属分类：">
              <span>
                {{ editProductForm.categoryName }}
              </span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <!-- v-if="ifEdit" -->
            <el-form-item label="销售范围：" class="p-relative">
              <span>
                {{ editProductForm.salesScope === 1 ? '全平台' : editProductForm.salesScope === 2 ? '仅协议客户' : '' }}
              </span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="计量单位：" prop="unitValue">
              <span>
                {{ editProductForm.unitValue }}
              </span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="市场公开价(元)：" prop="price">
              <span>
                {{ editProductForm.price }}
              </span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="库存：" prop="skuStock">
              <span>
                {{ editProductForm.skuStock }}
              </span>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="交货期：">
              <span>{{ formatDeliverType(editProductForm.deliveryType) }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="起订量：" prop="minOrderQuantity">
              <span>
                {{ editProductForm.minOrderQuantity }}
              </span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="订单是否确认：" prop="isConfirm">
              <span>
                {{ editProductForm.isConfirm === 1 ? '是' : editProductForm.isConfirm === 0 ? '否' : '' }}
              </span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="发货周期(天)：" prop="deliverTime">
              <span>
                {{ editProductForm.deliverTime }}
              </span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="商品编号：">
              <span>
                {{ editProductForm.skuCode }}
              </span>
            </el-form-item>
          </el-col>
        </el-row>
        <div>
          <div class="sub-title">属性</div>
          <el-row class="no-edit">
            <el-col v-for="(item, index) of editProductForm.specificationArr" :key="index" :span="12">
              <el-form-item :label="item.attributeName + '：'">
                <span>
                  {{ item.attributeValue }}
                </span>
              </el-form-item>
            </el-col>
          </el-row>
          <div class="sub-title">规格</div>
          <el-row class="no-edit">
            <el-col v-for="(item, index) of editProductForm.attrArr" :key="index" :span="12">
              <el-form-item :label="item.attributeName + '：'">
                <span>
                  {{ item.attributeValue }}
                </span>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </div>

      <div class="box">
        <div class="title">销售规则</div>
        <el-row>
          <el-col :span="12">
            <el-form-item label="可售区域设置：" class="p-relative" prop="salesScopeId">
              <span>
                {{ editProductForm.salesScopeId | areaFilter(areaArr) }}
              </span>
              <el-tooltip class="icon" effect="dark" content="Right Center 提示文字" placement="right">
                <div slot="content">
                  <p>销售范围：是指您的商品对全平台客户的销售范围；</p>
                  <p>全平台：表示对平台所有客户销售；</p>
                  <p>仅协议客户：表示对您设置的平台协议客户，以协议价销售；</p>
                </div>
                <div class="icon">?</div>
              </el-tooltip>
            </el-form-item>
          </el-col>
          <el-col :span="12"></el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="备注：">
              <el-input
                v-model="editProductForm.remark"
                style="border-radius: unset"
                type="textarea"
                maxlength="200"
                :autosize="{
                  minRows: 3,
                  maxRows: 8,
                }"
                show-word-limit
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12"></el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="附件：">
              <file-upload
                :upload-url="uploadUrl"
                :url="pdfFileList"
                accept=".pdf"
                :limit="10"
                :is-p-d-f="true"
                :file-size="20"
                :if-upload-btn="true"
                @getFileInfo="getFileInfo"
              >
                <template #message>最多上传 10个文件，仅限 PDF 格式，文件大小不能超过 20M</template>
              </file-upload>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <div class="box">
        <h2 class="title">商品图片</h2>
        <div class="sub-title">
          <span>商品图片</span>
          至少上传一张，最多5张图片，支持JPG、JPEG、PNG格式，正方形图片，建议使用800*800px，单张大小不超过4M。
        </div>
        <el-row>
          <el-col :span="24">
            <el-form-item label="商品图片：" required>
              <ul
                v-if="editProductForm.imageUrlsExist.length"
                class="el-upload-list el-upload-list--picture-card new-img-list"
              >
                <li v-for="(item, index) in editProductForm.imageUrlsExist" :key="index" class="el-upload-list__item">
                  <div class="img-shade">
                    <i class="el-icon-delete" @click="delProductImg(index)"></i>
                  </div>
                  <img :src="item" alt class="el-upload-list__item-thumbnail" />
                </li>
              </ul>
              <multi-image-upload
                v-if="editProductForm.imageUrlsExist.length < 5"
                :url="imageUrls"
                :has-del="true"
                :limit="imageUrlsLength"
                :image-size="4"
                :verify="true"
                :upload-tips.sync="imageUploadTips"
                @handleimgInfo="handleProducts"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <div class="sub-title">
          <span>商品详情图片</span>
          至少上传一张，最多10张图片，支持JPG、JPEG、PNG格式，正方形图片，建议使用800*800px，单张大小不超过4M。
        </div>
        <el-row>
          <el-col :span="24">
            <el-form-item label="商品详情图片：" required>
              <ul
                v-if="editProductForm.detailImageUrlsExist.length"
                class="el-upload-list el-upload-list--picture-card new-img-list"
              >
                <li
                  v-for="(item, index) in editProductForm.detailImageUrlsExist"
                  :key="index"
                  class="el-upload-list__item"
                >
                  <div class="img-shade">
                    <i class="el-icon-delete" @click="delDetailImg(index)"></i>
                  </div>
                  <img :src="item" alt class="el-upload-list__item-thumbnail" />
                </li>
              </ul>
              <!-- <multiImageUpload
                :url="editProductForm.detailImageUrlsExist"
                :hasDel="false"
                :hasUpload="false"
              />-->
              <multi-image-upload
                v-if="editProductForm.detailImageUrlsExist.length < 10"
                :url="detailImageUrls"
                :has-del="true"
                :limit="detailImageUrlsLength"
                :image-size="4"
                :verify="true"
                :upload-tips.sync="detailImageUploadTips"
                @handleimgInfo="handleProductsDetail"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <el-form-item class="submit-button">
        <el-button v-if="ifEdit" type="primary" @click="saveEditInfo">保存</el-button>
        <el-button type="primary" @click="submitEditInfo">提交审核</el-button>
        <el-button @click="goBack">取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import util from '../../../utils/utils';
import { epecToken } from '../../../utils/globalData';
import mixin from './mixin';
import api from '../../../api/product';
import FileUpload from './fileUpload.vue';

export default {
  name: 'ProductEdit',
  components: {
    FileUpload,
  },
  mixins: [mixin],
  props: {
    productAuditId: {
      type: Number,
      default: 0,
    },
    skuId: {
      type: Number,
      default: 0,
    },
    ifEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      skuNameV: '',
      remarkV: '',
      imageUrlsV: [],
      imageUrlsExistV: [],
      detailImageUrlsV: [],
      detailImageUrlsExistV: [],
      skuFilesV: [],
      // 主图
      submitImageUrlsV: [],
      // 详情图
      submitDetailImageUrlsV: [],
      ifEditV: false,
      uploadUrl: api.fileUploadForProductFile,
      attributeForm: {
        value: '',
        code: '',
        name: '',
      },
      attributeValueVisible: false,
      headers: epecToken,
      imageUploadTips: false,
      detailImageUploadTips: false,
      editProductForm: {
        // 商品名称
        skuName: '',
        // 品牌
        brandId: '',
        brandName: '',
        // 税率id
        taxRateId: '',
        taxRateValue: '',
        tax: '',
        // 计量单位
        unitId: '',
        unitValue: '',
        // 市场公开价
        price: '',
        // 库存
        skuStock: '',
        // 起订量
        minOrderQuantity: '',
        // 订单是否确认
        isConfirm: '',
        // 发货周期
        deliverTime: '',
        // 可售区域设置
        salesScopeId: '',
        // 备注
        remark: '',
        // 附件列表
        skuFiles: [],
        // 主图
        imageUrls: [],
        imageUrlsTest: [],
        // 详情图
        detailImageUrls: [],
        detailImageUrlsTest: [],
        // 主图图库
        imageUrlsExist: [],
        // 详情图图库
        detailImageUrlsExist: [],
      },
      // 主图列表
      imageUrls: [],
      detailImageUrls: [],
      showImgViewer: false,
      // pdf回显列表
      pdfFileList: [],
      standardList: [],
      attributeValueList: [],
      attributeIndex: 0,
      attributeValue: '',
      editProductFormRules: {
        taxRateId: [
          {
            type: 'number',
            required: true,
            validator: '请选择税率',
            trigger: 'change',
          },
        ],
      },
      // 主图
      submitImageUrls: [],
      // 详情图
      submitDetailImageUrls: [],
      // 接口数据
      resData: {},
      // 销售范围
      salesScopeType: [
        {
          value: '仅协议客户',
          key: 2,
        },
        {
          value: '全平台',
          key: 1,
        },
      ],
      salesScope: '',
      unitListAtt: [],
      formatVal: '',
      customName: '',
      flagSetNewAttr: false,
      attributeStr: '',
      detailImageUrlsLength: 0,
      imageUrlsLength: 0,
    };
  },
  computed: {
    newEditProductForm() {
      return JSON.parse(JSON.stringify(this.editProductForm));
    },
  },
  watch: {
    newEditProductForm: {
      handler(newVal) {
        // this.editProductForm.skuName = this.trim(this.editProductForm.skuName);
        const skuName = newVal.skuName || '';
        // 发布的 主图图库上传发生改变
        const imageUrlsExist = [...newVal.imageUrlsExist];
        const imageUrlsExistV = [...this.imageUrlsExistV];
        const imageUrlsExistFlag = this.isObjectValueEqual(imageUrlsExist, imageUrlsExistV);
        // 详情图 图库
        const detailImageUrlsExist = [...newVal.detailImageUrlsExist];
        const detailImageUrlsExistV = [...this.detailImageUrlsExistV];
        const detailImageUrlsExistFlag = this.isObjectValueEqual(detailImageUrlsExist, detailImageUrlsExistV);
        // 详情图 本地
        const detailImageUrls = [...newVal.detailImageUrlsTest];
        const detailImageUrlsV = [...this.submitDetailImageUrlsV];
        const detailImageUrlsFlag = this.isObjectValueEqual(detailImageUrls, detailImageUrlsV);

        const skuFiles = [...newVal.skuFiles];
        const skuFilesV = [...this.skuFilesV];
        const skuFilesFlag = this.isObjectValueEqual(skuFiles, skuFilesV);
        /* if (detailImageUrlsFlag) {
          console.log("详情图上传 没有 发生改变")
          this.ifEditV = false
        } else {
          console.log("详情图上传发生改变")
          this.ifEditV = true
        } */
        // 主图 本地
        const imageUrls = [...newVal.imageUrlsTest];
        const imageUrlsV = [...this.submitImageUrlsV];
        const imageUrlsFlag = this.isObjectValueEqual(imageUrls, imageUrlsV);

        /* const taxRateIdFlag = this.taxRateIdWatch === newVal.taxRateId;
        console.log(this.taxRateIdWatch, newVal.taxRateId, taxRateIdFlag); */

        console.log(this.trim(skuName) !== this.skuNameV, this.trim(skuName), this.skuNameV, '名字');
        console.log(detailImageUrlsExistFlag, 'detailImageUrlsExistFlag');
        console.log(imageUrlsExistFlag, 'imageUrlsExistFlag');
        console.log(imageUrlsFlag, 'imageUrlsFlag');
        console.log(detailImageUrlsFlag, 'detailImageUrlsFlag');
        // console.log(taxRateIdFlag, "taxRateIdFlag");

        if (
          this.trim(skuName) !== this.trim(this.skuNameV) ||
          !detailImageUrlsExistFlag ||
          !imageUrlsExistFlag ||
          !imageUrlsFlag ||
          !detailImageUrlsFlag ||
          !skuFilesFlag
        ) {
          console.log('发生了改变');
          this.ifEditV = true;
        } else {
          console.log('没有发生了改变');
          this.ifEditV = false;
        }
      },
      deep: true,
    },
  },
  created() {
    this.skuId && this.getMaintainProductDetail(this.skuId);
    this.productAuditId && this.getAuditProductDetail(this.productAuditId);
  },

  /* computed: {
    // 品牌（英文/中文名称）+空格+商品末级分类名称+空格+属性值1-N+规格值1-N（属性/规格值为该商品分类属性的前置符+取值+计量单位+后置符+连接符）
    skuName() {
      const brandName categoryName
    }
  }, */
  methods: {
    goBack() {
      const { currentIndex } = this.$route.query;
      console.log(currentIndex);
      this.$router.push({
        path: '/goodsMaintenance',
        query: {
          currentIndex,
        },
      });
    },
    isObjectValueEqual(a, b) {
      // 取对象a和b的属性名
      const aProps = Object.getOwnPropertyNames(a);
      const bProps = Object.getOwnPropertyNames(b);
      if (aProps.length !== bProps.length) {
        return false;
      }
      // 循环取出属性名，再判断属性值是否一致
      for (let i = 0; i < aProps.length; i++) {
        const propName = aProps[i];
        const type = typeof a[propName];
        if (type === 'object') {
          // 值是对象类型就递归
          if (!this.isObjectValueEqual(a[propName], b[propName])) {
            return false;
          }
        } else if (a[propName] !== b[propName]) {
          return false;
        }
      }
      return true;
    },
    // 删除商品图
    delProductImg(index) {
      this.$confirm('此操作将永久删除该图片, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.editProductForm.imageUrlsExist.splice(index, 1);
          this.$message({
            type: 'success',
            message: '删除成功!',
          });
        })
        .catch(() => {});
    },
    // 删除商品详情图
    delDetailImg(index) {
      this.$confirm('此操作将永久删除该图片, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.editProductForm.detailImageUrlsExist.splice(index, 1);
          this.$message({
            type: 'success',
            message: '删除成功!',
          });
        })
        .catch(() => {});
    },

    getFileInfo(fileList) {
      this.editProductForm.skuFiles = [...fileList];
      this.skuFilesV = JSON.parse(JSON.stringify([...fileList]));
    },

    /* // 修改税率  问题就是 label 是一个字符串而不是number类型 接口给的是number类型
    taxRateChange(taxRateId) {
      const taxRateObj = this.taxList.find(item => item.taxRateId === taxRateId);
      Object.assign(this.editProductForm, taxRateObj);
      this.editProductForm.taxRateId = taxRateObj.taxRateId;
      this.editProductForm.taxRateValue = Number(taxRateObj.taxRate);
    }, */
    // 获取商品详情图片地址
    handleProductsDetail(imageInfo) {
      this.submitDetailImageUrls = [...imageInfo];
      this.editProductForm.detailImageUrlsTest = [...imageInfo];
    },
    // 获取商品图片地址
    handleProducts(imageInfo) {
      this.submitImageUrls = [...imageInfo];
      this.editProductForm.imageUrlsTest = [...imageInfo];
    },
    // 打开图片查看器
    openImgViewer(file) {
      // 获取要查看的图片临时地址
      this.imgPreviewList = [file.url];
      // 显示图片查看器
      this.showImgViewer = true;
    },
    // 关闭图片查看器
    closeImgViewer() {
      this.showImgViewer = false;
    },
    // 获取分类下的单位列表
    async getUnitData(categoryId) {
      const res = await api.getUnitByCategory({
        categoryId,
      });
      if (+res.code === 200) {
        this.unitList = res.data;
      }
    },
    // 商品保存
    async saveEditInfo() {
      this.$refs.editProductForm.validate(async (valid) => {
        if (this.editProductForm.imageUrlsExist.length === 0 && this.submitImageUrls.length === 0) {
          this.imageUploadTips = true;
          return false;
        }
        if (this.editProductForm.detailImageUrlsExist.length === 0 && this.submitDetailImageUrls.length === 0) {
          this.detailImageUploadTips = true;
          return false;
        }

        if (valid) {
          this.editProductForm.imageUrls = this.submitImageUrls;
          this.editProductForm.detailImageUrls = this.submitDetailImageUrls;
          // this.editProductForm.defaultImage = this.submitImageUrls[0];
          this.editProductForm.defaultImage =
            this.submitImageUrls.length !== 0 ? this.submitImageUrls[0] : this.editProductForm.imageUrlsExist[0];
          // this.editProductForm.defaultImage = this.editProductForm.imageUrls[0];
          Object.assign(this.resData.productVO.skus[0], this.editProductForm);
          const params = {
            productAO: {
              ...this.resData.productVO,
            },
          };
          // 品牌和税率需要放在外层还有备注
          params.productAO.brandId = this.editProductForm.brandId;
          params.productAO.brandName = this.editProductForm.brandName;
          params.productAO.taxRateId = this.editProductForm.taxRateId;
          params.productAO.taxRateValue = this.editProductForm.taxRateValue;
          params.productAO.remark = this.editProductForm.remark || '';
          params.productAO.skuFiles = this.editProductForm.skuFiles || [];
          params.productAO.specificationStr = this.editProductForm.specificationStr; // this.attributeStr;
          this.resData.productVO.skus[0].specificationStr = this.editProductForm.specificationStr; // this.attributeStr;
          params.productAO.salesScopeId = this.editProductForm.salesScopeId;

          params.productAuditId = this.resData.productAuditId;
          console.log(params, 'params');
          const { submitProductDrafts } = api;
          const res = await submitProductDrafts(params);
          if (res.code === '200') {
            this.$message({
              message: '保存成功!',
              type: 'success',
            });
            // this.$router.go(-1);
            this.goBack();
          }
        }
      });
    },
    // 提交审核
    submitEditInfo() {
      const productName = util.deleteSpace(this.editProductForm.skuName);
      if (productName.length == 0) {
        this.$message.error('商品名称不能为空!');
        return;
      }
      this.$refs.editProductForm.validate(async (valid) => {
        /* if (this.submitImageUrls.length === 0) {
          this.imageUploadTips = true;
          return false;
        }
        if (this.submitDetailImageUrls.length === 0) {
          this.detailImageUploadTips = true;
          return false;
        } */
        if (this.editProductForm.imageUrlsExist.length === 0 && this.submitImageUrls.length === 0) {
          this.imageUploadTips = true;
          return false;
        }
        if (this.editProductForm.detailImageUrlsExist.length === 0 && this.submitDetailImageUrls.length === 0) {
          this.detailImageUploadTips = true;
          return false;
        }
        if (valid) {
          const { auditStatus = '' } = this.$route.query;
          if (this.productAuditId) {
            this.editProductForm.imageUrls = this.submitImageUrls;
            this.editProductForm.detailImageUrls = this.submitDetailImageUrls;
            this.editProductForm.defaultImage =
              this.submitImageUrls.length !== 0 ? this.submitImageUrls[0] : this.editProductForm.imageUrlsExist[0];
            // this.editProductForm.defaultImage = this.editProductForm.imageUrls[0];
            Object.assign(this.resData.productVO.skus[0], this.editProductForm);
            const params = {};
            params.productAO = this.resData.productVO;
            params.productAO.salesScope = this.editProductForm.salesScope;
            params.productAO.salesScopeId = this.editProductForm.salesScopeId;
            params.productAuditId = this.resData.productAuditId;

            // 品牌和税率需要放在外层
            params.productAO.brandId = this.editProductForm.brandId;
            params.productAO.brandName = this.editProductForm.brandName;
            params.productAO.taxRateId = this.editProductForm.taxRateId;
            params.productAO.taxRateValue = this.editProductForm.taxRateValue;
            params.productAO.remark = this.editProductForm.remark;
            params.productAO.skuFiles = this.editProductForm.skuFiles || [];
            params.productAO.specificationStr = this.editProductForm.specificationStr; // this.attributeStr;
            this.resData.productVO.skus[0].specificationStr = this.editProductForm.specificationStr; // this.attributeStr;

            console.log(params);
            const { unsubmitProductRelease, productReleaseSubmitAgain } = api;
            if (auditStatus === '104') {
              const res = await productReleaseSubmitAgain(params);
              if (res.code === '200') {
                this.$message({
                  message: '提交审核成功',
                  type: 'success',
                });
                // this.$router.go(-1);
                this.goBack();
              }
            } else {
              const res = await unsubmitProductRelease(params);
              if (res.code === '200') {
                const { data } = res;
                if (data.errorCount === 1) {
                  this.$message({
                    type: 'warning',
                    message: data.errorContent,
                  });
                } else {
                  this.$message({
                    message: '提交成功，可在商品维护列表查看商品审核进度。',
                    type: 'success',
                  });
                }
                this.goBack();
                // this.$router.go(-1);
              }
            }
          } else {
            // 这个是上下架的编辑提交
            this.editProductForm.imageUrls = this.submitImageUrls;
            this.editProductForm.detailImageUrls = this.submitDetailImageUrls;
            this.editProductForm.defaultImage =
              this.submitImageUrls.length !== 0 ? this.submitImageUrls[0] : this.editProductForm.imageUrlsExist[0];
            Object.assign(this.resData.skus[0], this.editProductForm);
            const params = {
              ...this.resData,
            };
            params.salesScope = this.editProductForm.salesScope;
            params.salesScopeId = this.editProductForm.salesScopeId;

            params.taxRateId = this.editProductForm.taxRateId;
            params.taxRateValue = this.editProductForm.taxRateValue;
            params.remark = this.editProductForm.remark;
            params.skuFiles = this.editProductForm.skuFiles;

            // console.log(params);

            const { productEditRelease } = api;
            const res = await productEditRelease(params);
            if (res.code === '200') {
              this.$message({
                message: '编辑成功!',
                type: 'success',
              });
              // this.$router.go(-1);
              this.goBack();
            }
          }

          // alert("submit!");
        } else {
          return false;
        }
      });
    },
    // 获取维护商品的详情-上下架详情  外层是属性，内层是规格
    async getMaintainProductDetail(skuId) {
      const { querySkuInfoForEdite } = api;
      try {
        this.productDetailIng = true;
        const res = await querySkuInfoForEdite({
          skuId,
        });
        this.productDetailIng = false;
        if (res.code === '200') {
          const data = res.data?.skus[0];
          this.resData = res.data;
          // 编辑回显图片
          if (data.imageUrls?.length) {
            this.imageUrls = [...data.imageUrls];
            this.submitImageUrls = [...data.imageUrls];
          }
          if (data.detailImageUrls?.length) {
            this.detailImageUrls = [...data.detailImageUrls];
            this.submitDetailImageUrls = [...data.detailImageUrls];
          }

          /* const imageUrls = data.imageUrls?.length ? data.imageUrls : [];
          const imageUrlsExist = data.imageUrlsExist?.length ? data.imageUrlsExist : [];
          this.imageUrls = [...imageUrls, ...imageUrlsExist];


          const detailImageUrls = data.detailImageUrls?.length ? data.detailImageUrls : [];
          const detailImageUrlsExist = data.detailImageUrlsExist?.length ? data.detailImageUrlsExist : [];
          this.detailImageUrls = [...detailImageUrls, ...detailImageUrlsExist]; */

          const specificationArr = res.data?.attributes;
          const attrArr = data.attributes;
          data.attrArr = attrArr;
          data.specificationArr = specificationArr;
          this.salesScope = data.salesScope;
          this.editProductForm = { ...this.editProductForm, ...data }; // 使用这个对象相应
          this.taxRateIdWatch = this.editProductForm.taxRateId;
          // this.editProductForm = { ...data };
          this.imageUrlsLength = 5 - this.editProductForm.imageUrlsExist.length;
          this.detailImageUrlsLength = 10 - this.editProductForm.detailImageUrlsExist.length;
          this.pdfFileList = data.skuFiles ? data.skuFiles : res.data.skuFiles;

          this.skuNameV = this.editProductForm.skuName;
          // this.remarkV = this.editProductForm.remark || ""

          this.imageUrlsExistV = JSON.parse(JSON.stringify([...this.editProductForm.imageUrlsExist]));
          this.detailImageUrlsExistV = JSON.parse(JSON.stringify([...this.editProductForm.detailImageUrlsExist]));

          this.editProductForm.detailImageUrlsTest = this.editProductForm.detailImageUrls;
          this.editProductForm.imageUrlsTest = this.editProductForm.imageUrls;

          this.submitDetailImageUrlsV = JSON.parse(JSON.stringify([...this.editProductForm.detailImageUrlsTest]));
          this.submitImageUrlsV = JSON.parse(JSON.stringify([...this.editProductForm.imageUrlsTest]));
          // 去掉表单回显验证
          this.$refs.editProductForm.resetFields();
          const { categoryId } = res.data;
          // 获取品牌名称
          this.getBrandList(categoryId);
          // 属性
          this.getAttributeData(categoryId);
          // 单位
          this.getUnitData(categoryId);
          // 规格
          this.getPropertyList(categoryId);
        } else {
          // this.$router.go(-1);
          setTimeout(() => {
            this.goBack();
          }, 3000);
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 商品审核详情  外层是属性，内层是规格
    async getAuditProductDetail(productAuditId) {
      const { queryReleaseProductInfoById } = api;
      try {
        this.productDetailIng = true;
        const res = await queryReleaseProductInfoById({
          productAuditId,
        });
        this.productDetailIng = false;
        if (res.code === '200') {
          const data = res.data?.productVO?.skus[0];
          this.resData = res.data;
          data.skuCode = res.data.skuCode;
          const specificationArr = res.data?.productVO.attributes;
          const attrArr = data.attributes;
          data.attrArr = attrArr;
          data.specificationArr = specificationArr;
          if (data.imageUrls?.length) {
            this.imageUrls = [...data.imageUrls];
            this.submitImageUrls = [...data.imageUrls];
          }
          if (data.detailImageUrls?.length) {
            this.detailImageUrls = [...data.detailImageUrls];
            this.submitDetailImageUrls = [...data.detailImageUrls];
          }

          /* const imageUrls = data.imageUrls?.length ? data.imageUrls : [];
          const imageUrlsExist = data.imageUrlsExist?.length ? data.imageUrlsExist : [];
          this.imageUrls = [...imageUrls, ...imageUrlsExist];

          const detailImageUrls = data.detailImageUrls?.length ? data.detailImageUrls : [];
          const detailImageUrlsExist = data.detailImageUrlsExist?.length ? data.detailImageUrlsExist : [];
          this.detailImageUrls = [...detailImageUrls, ...detailImageUrlsExist]; */

          this.salesScope = data.salesScope;
          this.editProductForm = { ...this.editProductForm, ...data }; // 使用这个对象相应
          this.editProductForm.salesScope = data.salesScope ? data.salesScope : res.data.productVO.salesScope || null;
          this.editProductForm.taxRateId = data.taxRateId ? data.taxRateId : res.data.productVO.taxRateId;
          this.taxRateIdWatch = this.editProductForm.taxRateId;
          this.editProductForm.taxRateValue = data.taxRateValue ? data.taxRateValue : res.data.productVO.taxRateValue;
          this.editProductForm.salesScopeId = data.salesScopeId
            ? data.salesScopeId
            : res.data.productVO.salesScopeId
            ? res.data.productVO.salesScopeId
            : '';
          this.editProductForm.brandId = data.brandId ? data.brandId : res.data.productVO.brandId;
          this.editProductForm.brandName = data.brandName ? data.brandName : res.data.productVO.brandName;

          this.editProductForm.categoryId = data.categoryId ? data.categoryId : res.data.productVO.categoryId || null;
          this.editProductForm.categoryName = data.categoryName
            ? data.categoryName
            : res.data.productVO.categoryName || null;
          this.editProductForm.productId = data.productId ? data.productId : res.data.productVO.productId || null;
          this.pdfFileList = data.skuFiles ? data.skuFiles : res.data.productVO.skuFiles;
          this.editProductForm.skuFiles = data.skuFiles ? data.skuFiles : res.data.productVO.skuFiles;
          this.editProductForm.remark = data.remark ? data.remark : res.data.productVO.remark;

          /* const imageUrls = data.imageUrls?.length ? data.imageUrls : [];
          const imageUrlsExist = data.imageUrlsExist?.length ? data.imageUrlsExist : [];
          this.imageUrls = [...imageUrls, ...imageUrlsExist];
          console.log(this.imageUrls, "this.imageUrlsthis.imageUrls");

          const detailImageUrls = data.detailImageUrls?.length ? data.detailImageUrls : [];
          const detailImageUrlsExist = data.detailImageUrlsExist?.length ? data.detailImageUrlsExist : [];
          this.detailImageUrls = [...detailImageUrls, ...detailImageUrlsExist];
          console.log(this.detailImageUrls, "this.detailImageUrlsthis.detailImageUrls"); */

          console.log(this.editProductForm, 'this.editProductForm商品审核详情');
          this.imageUrlsLength = 5 - this.editProductForm.imageUrlsExist.length;
          this.detailImageUrlsLength = 10 - this.editProductForm.detailImageUrlsExist.length;
          // 去掉表单回显验证
          this.$refs.editProductForm.resetFields();
          const { categoryId } = res.data.productVO;

          this.skuNameV = this.editProductForm.skuName;
          // this.remarkV = this.editProductForm.remark || ""

          this.imageUrlsExistV = JSON.parse(JSON.stringify([...this.editProductForm.imageUrlsExist]));
          this.detailImageUrlsExistV = JSON.parse(JSON.stringify([...this.editProductForm.detailImageUrlsExist]));

          this.editProductForm.detailImageUrlsTest = this.editProductForm.detailImageUrls;
          this.editProductForm.imageUrlsTest = this.editProductForm.imageUrls;

          this.submitDetailImageUrlsV = JSON.parse(JSON.stringify([...this.editProductForm.detailImageUrlsTest]));
          this.submitImageUrlsV = JSON.parse(JSON.stringify([...this.editProductForm.imageUrlsTest]));

          // 获取品牌名称
          this.getBrandList(categoryId);
          // 属性
          this.getAttributeData(categoryId);
          // 单位
          this.getUnitData(categoryId);
          // 规格
          this.getPropertyList(categoryId);
        } else {
          // this.$router.go(-1);
          this.goBack();
        }
      } catch (error) {
        console.log(error);
      }
    },
    trim(str) {
      // 删除左右两端的空格
      return str.replace(/(^\s*)|(\s*$)/g, '');
    },
    formatDeliverType(type) {
      console.log(type);
      return type != undefined && type != null ? (type === 2 ? '期货' : '现货') : '现货';
    },
  },
};
</script>
<style lang="scss" scoped>
.edit-product {
  .box {
    padding: 20px 20px 0 20px;
    background: #fff;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    margin-top: 20px;

    &:first-child {
      margin-top: 0;
    }

    &:last-child {
      padding-bottom: 20px;
    }

    ::v-deep .el-select .el-input .el-select__caret {
      color: #666;
    }
    /* ::v-deep .el-input__inner {
      border-color: #2587FF;
    } */
    ::v-deep .el-textarea__inner {
      border-radius: 0;
    }
    ::v-deep .warn-message {
      color: #999;
    }
  }
  ::v-deep .el-upload-list__item {
    transition: none;
  }
  .new-img-list {
    ::v-deep .el-upload-list__item {
      transition: none;
    }
    .el-upload-list__item {
      position: relative;
      &:hover {
        .img-shade {
          display: block;
        }
      }
      .img-shade {
        display: none;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.5);
        position: absolute;
        left: 0;
        top: 0;
        .el-icon-delete {
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          color: #fff;
          font-size: 20px;
        }
      }
    }
  }
  .value-form {
    ::v-deep .el-form {
      border: 1px solid #ededed;
      .attribute-title {
        background: #f5f5f5;
        color: #333333;
        border-bottom: 1px solid #ededed;
        .el-form-item__label {
          height: 40px;
          line-height: 40px;
          margin-top: 0 !important;
        }
        .el-form-item__content {
          padding: 0 0 0 10px !important;
          height: 40px;
          line-height: 40px;
        }
      }
      .el-form-item {
        margin-bottom: 0;
        border-bottom: 1px solid #ededed;
        .el-form-item__error {
          bottom: 2px;
          left: 10px;
          top: auto;
        }
        .el-form-item__label {
          margin-top: 8px;
          height: 40px;
          line-height: 40px;
        }
      }
      .el-form-item__content {
        border-left: 1px solid #ededed;
        padding-bottom: 20px;
        .el-radio-group {
          margin-left: 10px;
          padding-top: 20px;
        }
      }
      .attribute-add {
        .el-form-item__content {
          padding-bottom: 0;
        }
        .attribute-add-item {
          margin-left: 10px;
          padding-bottom: 10px;
        }
      }
      .value-item-form {
        border-bottom: 0;
      }
      .el-button {
        border-radius: 0;
      }
    }
    ::v-deep .el-radio {
      min-width: 100px;
    }
  }

  .prudoct-form {
    ::v-deep .el-form-item__content {
      width: calc(100% - 160px);
      margin-left: 0 !important;
      display: inline-block;
    }

    ::v-deep .el-form-item__label {
      font-size: 14px;
    }

    ::v-deep .el-form-item {
      margin-bottom: 20px;
      line-height: 1;
    }

    .no-edit {
      ::v-deep .el-form-item__label {
        line-height: 1;
      }

      ::v-deep .el-form-item__content {
        line-height: 1;
      }
    }
  }

  .title {
    width: 100%;
    line-height: 1;
    font-size: 16px;
    margin-bottom: 18px;
  }

  .sub-title {
    line-height: 40px;
    font-size: 14px;
    margin-bottom: 20px;
    background: #f5f5f5;
    padding-left: 20px;
  }

  .img-desc {
    padding: 0 0 6px 40px;
    font-size: 12px;
    line-height: 22px;
    margin-top: -10px;
    border-bottom: 1px solid #eee;
  }

  .upload-img {
    margin: 18px 118px;
  }

  .el-select {
    width: 100%;
  }

  .p-relative {
    position: relative;
    .icon {
      position: absolute;
      right: -30px;
      top: 5px;
      width: 22px;
      height: 22px;
      line-height: 22px;
      text-align: center;
      border-radius: 50%;
      border: 1px solid #c5c5c5;
      font-size: 12px;
      color: #c5c5c5;
      cursor: pointer;
      &:hover {
        background: #c5c5c5;
        color: #fff;
      }
    }
  }

  .hideRemove ::v-deep .el-upload-list__item-delete {
    display: none !important;
  }

  .hideRemove ::v-deep .el-upload--picture-card {
    display: none !important;
  }

  .img-delail {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .submit-button {
    margin: 20px 0 30px 0;
    text-align: center;
  }
}
</style>
